









import { RootStoreState } from '@empathybroker/ebx-gluon';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { CdlResult } from '../../models/result.model';

@Component({
  computed: {
    ...mapState({
      textLocalIcon: (state: Partial<RootStoreState>) =>
          state.config.dynamic.textLocalIcon,
      localIcon: (state: Partial<RootStoreState>) =>
          state.config.dynamic.localIcon,
    })
  }
})
export default class CdlResultLocalProduct extends Vue {
  @Prop({ required: true })
  protected item: CdlResult;
}
